import React, { useMemo } from 'react';
import './MemoryTimeline.css';

const LABEL_COLORS = {
  'experiences': '#3b725f',
  'preferences': '#7f5f43',
  'relationships': '#bd7b69',
  'memories': '#cccac5',
  'thoughts': '#D8BFD8',
  'Work': '#FF6B6B',
  'Family': '#4ECDC4',
  'Personal': '#45B7D1',
  'Private': '#96CEB4',
  'Health': '#FECA57',
  'Finance': '#48DBFB',
  'Education': '#FF9FF3',
  'Hobby': '#54A0FF',
  'Travel': '#FD79A8',
  'Social': '#A29BFE',
  'Goals': '#6C5CE7',
  'Ideas': '#FFC048',
};

function groupByDate(memories) {
  const groups = {};
  memories.forEach(m => {
    const d = new Date(m.timestamp);
    const key = d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    if (!groups[key]) groups[key] = { date: d, memories: [] };
    groups[key].memories.push(m);
  });
  return Object.entries(groups)
    .sort(([, a], [, b]) => b.date - a.date)
    .map(([label, { memories: mems }]) => ({ label, memories: mems }));
}

function MemoryTimeline({ memories, onMemoryClick }) {
  const groups = useMemo(() => groupByDate(memories), [memories]);

  if (memories.length === 0) {
    return <div className="tl-empty">No memories yet. Start a conversation to build your timeline.</div>;
  }

  return (
    <div className="tl-root">
      <div className="tl-line" />
      {groups.map((group) => (
        <div key={group.label} className="tl-group">
          <div className="tl-date-badge">{group.label}</div>
          {group.memories.map((memory) => {
            const color = LABEL_COLORS[memory.category] || '#3b725f';
            return (
              <div
                key={memory.id}
                className="tl-card"
                onClick={() => onMemoryClick && onMemoryClick(memory)}
              >
                <div className="tl-dot" style={{ background: color }} />
                <div className="tl-card-inner">
                  <div className="tl-card-header">
                    <span className="tl-category" style={{ background: color }}>
                      {memory.category}
                    </span>
                    <span className="tl-time">
                      {new Date(memory.timestamp).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })}
                    </span>
                  </div>
                  <p className="tl-text">{memory.text}</p>
                  {memory.labels && memory.labels.length > 0 && (
                    <div className="tl-labels">
                      {(Array.isArray(memory.labels) ? memory.labels : []).map(label => (
                        <span key={label} className="tl-label" style={{ borderColor: LABEL_COLORS[label] || '#666', color: LABEL_COLORS[label] || '#666' }}>
                          {label}
                        </span>
                      ))}
                    </div>
                  )}
                  {memory.notes && (
                    <p className="tl-notes">{memory.notes}</p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}

export default MemoryTimeline;
